import DeliveriesSerializer from './deliveries';

export default class NotificationConfigSerializer extends DeliveriesSerializer {
  attrs = {
    canAccessSlack: {
      serialize: false,
    },
  };
}
